import React from 'react';

import { Surface } from '@infoods/lifebase-ui';

import classes from './NgzCustomerGoHighLevelWidget.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { useCustomerGoHighLevelConnection } from './hooks/useCustomerGoHighLevelConnection';
import { ConnectionManagement } from './ConnectionManagement/ConnectionManagement';
import { TitleSection } from './TitleSection/TitleSection';
import { CUSTOMER_TYPE } from '../../../shared/constants/customer/customerType';

type NgzCustomerGoHighLevelWidgetProps = { customerId: number } & (
  | { customerType: typeof CUSTOMER_TYPE.SCAN_IQ; entityId: number }
  | { customerType: typeof CUSTOMER_TYPE.NUTRITION; entityId?: number }
);

const NgzCustomerGoHighLevelWidget = ({
  customerId,
  customerType,
  entityId,
}: NgzCustomerGoHighLevelWidgetProps) => {
  const { accountInfo, refreshConnectionInfo } = useCustomerGoHighLevelConnection(
    customerId,
    customerType,
    entityId,
  );

  return (
    <Surface className={classes.box}>
      <TitleSection contactId={accountInfo?.contactId} />
      <ConnectionManagement
        contactId={accountInfo?.contactId}
        onRefresh={refreshConnectionInfo}
      />
    </Surface>
  );
};

angularizeWithProviders(NgzCustomerGoHighLevelWidget, 'ngzCustomerGoHighLevelWidget', {
  customerId: '<',
  customerType: '@',
});

export { NgzCustomerGoHighLevelWidget };
